import { FormControl, Grid, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import React, { useState } from "react";
import { useFetchFacturaCats } from "../../../hooks/useFetchFacturaCats";
import { LoadingDialog } from "../dialogs/LoadingDialog";

export const DatosFactura = (props) => {
    const onTrigger = (event) => {
        switch (event.target.name) {
            case "factNombre":
                event.target.value.trim().length < 3
                    ? setOnErrorNombre(true)
                    : setOnErrorNombre(false);
                break;
            // case "factRfc":
            case "factRFC":
                event.target.value.trim().length < 12 ? setOnErrorRfc(true) : setOnErrorRfc(false);
                break;
            case "factCP":
                event.target.value.trim().length < 5 ? setOnErrorCp(true) : setOnErrorCp(false);
                break;
            case "factUsoCFDI":
                event.target.value.trim().length < 1
                    ? setOnErrorUsoCFDI(true)
                    : setOnErrorUsoCFDI(false);
                break;
            case "factRegimenFiscal":
                event.target.value.trim().length < 1
                    ? setOnErrorRegimenFiscal(true)
                    : setOnErrorRegimenFiscal(false);
                break;
            default:
                break;
        }

        props.parentCallback(event);
    };

    const [OnErrorRfc, setOnErrorRfc] = useState(false);
    const [OnErrorNombre, setOnErrorNombre] = useState(false);
    const [OnErrorCp, setOnErrorCp] = useState(false);
    const [OnErrorUsoCFDI, setOnErrorUsoCFDI] = useState(false);
    const [OnErrorRegimenFiscal, setOnErrorRegimenFiscal] = useState(false);

    const { dataCDFIs, dataRFs, loading } = useFetchFacturaCats();

    return (
        <Grid container spacing={1} >
            <Grid item xs={12}>
                <TextField
                    defaultValue={""}
                    error={OnErrorNombre}
                    fullWidth
                    id="factNombre"
                    label="Nombre completo"
                    name="factNombre"
                    onChange={onTrigger}
                    required
                    size="small"
                    variant={props.variant}
                />
            </Grid>
            <Grid item xs={8}>
                <TextField
                    defaultValue={props.value}
                    error={OnErrorRfc}
                    fullWidth
                    // id="factRfc"
                    id="factRFC"
                    label="RFC"
                    // name="factRfc"
                    name="factRFC"
                    onChange={onTrigger}
                    required
                    size="small"
                    variant={props.variant}
                />
            </Grid>
            <Grid item xs={4}>
                <TextField
                    defaultValue={""}
                    error={OnErrorCp}
                    fullWidth
                    id="factCP"
                    label="C.P."
                    name="factCP"
                    onChange={onTrigger}
                    required
                    size="small"
                    variant={props.variant}
                    type="number"
                />
            </Grid>
            <Grid item xs={12}>

                <FormControl fullWidth required size="small">
                    <InputLabel id="select-usocfdi">Uso CFDI</InputLabel>
                    <Select
                        defaultValue={""}
                        error={OnErrorUsoCFDI}
                        id="factUsoCFDI"
                        label="Uso CFDI"
                        name="factUsoCFDI"
                        onChange={onTrigger}
                    >
                        {dataCDFIs.map(({ value, label }) => (
                            <MenuItem value={ value } key={ value } >{ label }</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={12}>
                <FormControl fullWidth size="small" required>
                    <InputLabel id="select-regimenfiscal">Regimen fiscal</InputLabel>
                    <Select
                        defaultValue={""}
                        error={OnErrorRegimenFiscal}
                        id="factRegimenFiscal"
                        label="Regimen fiscal"
                        name="factRegimenFiscal"
                        onChange={onTrigger}
                    >
                        {dataRFs.map(({ value, label }) => (
                            <MenuItem value={ value } key={ value } >{ label }</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
            {/* Dialog de carga del inicio */}
            { loading ? <LoadingDialog /> : '' }
                
        </Grid>

    );
};
